import { render, staticRenderFns } from "./MdtMailPreviewTemplateList.vue?vue&type=template&id=4fdcbd5a&scoped=true"
import script from "./MdtMailPreviewTemplateList.vue?vue&type=script&lang=js"
export * from "./MdtMailPreviewTemplateList.vue?vue&type=script&lang=js"
import style0 from "./MdtMailPreviewTemplateList.vue?vue&type=style&index=0&id=4fdcbd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdcbd5a",
  null
  
)

export default component.exports